module.exports = __webpack_public_path__ + "static/media/assassin1.3a0fb538.png";